let SEARCHRESULTS;  // current


$(document).ready(function () {
    clearSearchResults();

    initSearchUi();
    initResultsUi();

    setInterval(function () {
        updateUrlParams();
    }, 2 * 1000);

    initLoadUrlParams();
});


function initLoadUrlParams () {
    const params = $.url().param();
    let goaheadandtrigger = false;

    // keywords: comma-separated set of phrases, to be inserted into the select2 box as new terms
    if (params.textsearch) {
        const values = params.textsearch.split(',');
        const $box = $('#searchform select[name="textsearch"]');

        values.forEach((thisvalue) => {
            $(`<option selected></option>`).prop('value', thisvalue).text(thisvalue).appendTo($box);
        });

        $box.change();

        goaheadandtrigger = true;
    }

    // most terms are comma-separated IDs and we simply select those values
    if (params.boxfolder) {
        const values = params.boxfolder.split(',');
        const $box = $('#searchform select[name="boxfolder"]');
        $box.val(values).change();
        goaheadandtrigger = true;
    }
    if (params.authors) {
        const values = params.authors.split(',');
        const $box = $('#searchform select[name="authors"]');
        $box.val(values).change();
        goaheadandtrigger = true;
    }
    if (params.doctypes) {
        const values = params.doctypes.split(',');
        const $box = $('#searchform select[name="doctypes"]');
        $box.val(values).change();
        goaheadandtrigger = true;
    }
    if (params.keywords) {
        const values = params.keywords.split(',');
        const $box = $('#searchform select[name="keywords"]');
        $box.val(values).change();
        goaheadandtrigger = true;
    }

    // documentdate is comma-joined docdatemin and docdatemax
    if (params.docdate && params.docdate != ',') {
        const values = params.docdate.split(',');
        if (values.length == 2 && values[0] && values[1]) {
            $('#searchform select[name="docdatemin"]').val(values[0]);
            $('#searchform select[name="docdatemax"]').val(values[1]);
        }
        goaheadandtrigger = true;
    }

    // sort and select page
    if (params.sort && params.sort.match(/^\w+\,\w+$/)) {
        const field = params.sort.split(',')[0];
        const ascdesc = params.sort.split(',')[1];
        $('#searchresults .searchpagination select[name="sort_field"]').val(field);
        $('#searchresults .searchpagination select[name="sort_ascdesc"]').val(ascdesc);
    }

    if (params.page && params.page.match(/^\d+$/)) {
        setCurrentPageNumber(params.page);
    }

    // table or tile
    if (params.tileview) {
        $('#searchresults a[data-results-view="tiles"]').click();
    }
    else {
        $('#searchresults a[data-results-view="table"]').click();
    }

    // done loading params; should we go ahead and submit?
    if (goaheadandtrigger) {
        $('#searchform').submit();
    }
}


function initSearchUi () {
    // those spiffy multiple-choice select menus
    // read their data-placeholder= attribute and assign this to the Select2 placeholder
    // the "searchterms" one is quite different: no options, only arbitrary submissions; so break it out specifically
    $('select[name="boxfolder"]').each(function () {
        let placeholder = $(this).attr('data-placeholder');
        if (! placeholder) placeholder = "";
        $(this).select2({
            // allowClear: true,  // disabled: the X makes over-length options fall down to a new line, looks bad
            placeholder: placeholder
        });
    });
    $('select[name="textsearch"]').select2({
        placeholder: $(this).attr('data-placeholder'),
        language: {
            noResults: function() {
                return "Type phrases and press enter or comma";
            }
        },
        // allowClear: true,  // disabled: the X makes over-length options fall down to a new line, looks bad
        tags: true,
        tokenSeparators: [','],
        createTag: function (params) {
            const term = $.trim(params.term).replace(/[^\s\w\-]/g, '');
            if (term === '') return null; // blank  = skip it

            return {
              id: term,
              text: term,
              newTag: true,
            };
        }
    });
    $('select[name="doctypes"]').select2({
        placeholder: $(this).attr('data-placeholder'),
        language: {
            noResults: function() {
                return "Click here or start typing to filter the list of document types";
            }
        },
    });
    $('select[name="keywords"]').select2({
        placeholder: $(this).attr('data-placeholder'),
        language: {
            noResults: function() {
                return "Click here or start typing to filter the list of keyword tags";
            }
        },
    });
    $('select[name="authors"]').select2({
        placeholder: $(this).attr('data-placeholder'),
        language: {
            noResults: function() {
                return "Click here or start typing to filter the list of authors";
            }
        },
    });

    // the form is AJAX-driven
    const $busymodal = $('#pleasewait');
    $('#searchform').ajaxForm({
        dataType: 'json',
        beforeSerialize: function ($form) {
            // make sure they specified something in some box somewhere
            let has_anything = false;
            $form.find('select').each(function () {
                if ( $(this).val().length ) {
                    has_anything = true;
                }
            });
            if (! has_anything) { alert("Enter a search."); return false; }

            // if they entered a documentdatemin or a documentdatemax, they need to have entered both
            const hasdocdatemin = $form.find('select[name="docdatemin"]').val();
            const hasdocdatemax = $form.find('select[name="docdatemax"]').val();
            if ((hasdocdatemin && ! hasdocdatemax) || (! hasdocdatemin && hasdocdatemax)) { alert("To search by date, enter both dates."); return false; }

            // hack: the sorting UI is on the results panel, but we need to pretend it's here in the search form
            let sort_field = $('#searchresults .searchpagination select[name="sort_field"]').first().val();
            let sort_ascdesc = $('#searchresults .searchpagination select[name="sort_ascdesc"]').first().val();
            $form.find('input[name="sort_field"]').val(sort_field);
            $form.find('input[name="sort_ascdesc"]').val(sort_ascdesc);

            // page number is already in the form; see getCurrentPageNumber() and setCurrentPageNumber()

            // ready!
            return true;
        },
        beforeSubmit: function () {
            $busymodal.modal('show');
            logSearchAnalytics();
            disableSearchButton();
        },
        success: function (response) {
            $busymodal.modal('hide');
            enableSearchButton();
            SEARCHRESULTS = response;
            handleSearchResults();
        },
        error: function (xhr) {
            $busymodal.modal('hide');
            enableSearchButton();
            alert(xhr.statusText);
        },
    });
}


function initResultsUi () {
    // the clear/reset button
    const $searchclearbutton = $('#searchresults .searchclear button');
    $searchclearbutton.click(function () {
        clearSearchResults();
    });

    // prev/next buttons and sort buttons, both submit a new search for new data
    // some will also need to reset to page 1
    // for the goofy duplicate top-and-bottom sorting UI, additional care is needed
    // that when one is changed the other changes as well
    const $prevbutton = $('#searchresults .searchpagination').find('i[data-role="prev"]');
    const $nextbutton = $('#searchresults .searchpagination').find('i[data-role="next"]');
    const $sortby_field = $('#searchresults .searchpagination select[name="sort_field"]');
    const $sortby_ascdesc = $('#searchresults .searchpagination select[name="sort_ascdesc"]');

    $prevbutton.click(function () {
        setCurrentPageNumber(getCurrentPageNumber() - 1);
        $('#searchform').submit();
    });
    $nextbutton.click(function () {
        setCurrentPageNumber(getCurrentPageNumber() + 1);
        $('#searchform').submit();
    });
    $sortby_field.change(function () {
        const $this = $(this);
        $sortby_field.not($this).val($this.val());  // set the other one to match this one; the top one is actually used

        setCurrentPageNumber(1);
        $('#searchform').submit();
    });
    $sortby_ascdesc.change(function () {
        const $this = $(this);
        $sortby_ascdesc.not($this).val($this.val());  // set the other one to match this one; the top one is actually used

        setCurrentPageNumber(1);
        $('#searchform').submit();
    });

    // the table/tile buttons
    const $tabletilebuttons = $('#searchresults a[data-results-view]');
    $tabletilebuttons.click(function () {
        const $this = $(this);
        const which = $this.attr('data-results-view');
        selectResultsView(which);
    });
}


function disableSearchButton () {
    const $button = $('#searchform button').prop('disabled', true);
    $button.children('span').text('One Moment Please...');
}


function enableSearchButton () {
    const $button = $('#searchform button').removeAttr('disabled');
    $button.children('span').text('Search');
}


function handleSearchResults () {
    const $searchform = $('#searchform');
    const searched_textsearch = $searchform.find('[name="textsearch"]').val();
    const searched_boxfolder = $searchform.find('[name="boxfolder"]').val();

    if (! SEARCHRESULTS.resultspage || ! SEARCHRESULTS.resultspage.length) {
        alert("No documents matched your search.");
        clearSearchResults();
        return;
    }

    // show the results panel section (which has 2 readouts: table and tiles) and hide the search form
    $('#searchresults').show();
    $('#searchform').hide();
    $('#noresults').hide();

    // fill in page number, page count, etc.
    $('#searchresults span[data-role="results-count"]').text(SEARCHRESULTS.resultcount.toLocaleString());
    $('#searchresults .searchpagination span[data-role="howmanypages"]').text(SEARCHRESULTS.pagecount.toLocaleString());
    $('#searchresults .searchpagination span[data-role="pagenumber"]').text(SEARCHRESULTS.pagenumber.toLocaleString());

    // show/hide the prev/next buttons
    const $prevbutton = $('#searchresults .searchpagination').find('i[data-role="prev"]');
    const $nextbutton = $('#searchresults .searchpagination').find('i[data-role="next"]');
    if (SEARCHRESULTS.pagenumber <= 1) $prevbutton.addClass('noshow');
    else $prevbutton.removeClass('noshow');
    if (SEARCHRESULTS.pagenumber >= SEARCHRESULTS.pagecount) $nextbutton.addClass('noshow');
    else $nextbutton.removeClass('noshow');

    // fill in a block on the results telling them what they searched for, in case they forgot
    let searchterms_textsearch = '';
    let searchterms_boxfolder = '';
    if (searched_textsearch.length) {
        const phrases = searched_textsearch.length > 1 ? 'phrases' : 'phrase';
        const thelist = searched_textsearch.join(", ");
        searchterms_textsearch = `${phrases} <b>${thelist}</b>`;
    }
    if (searched_boxfolder.length) {
        const boxterms = searched_boxfolder.map((boxfolder) => {
            const words = boxfolder.split(' ');
            if (words.length == 1) return `Box ${boxfolder}`;
            return `Box ${words[0]} Folder ${words[1]}`;
        });
        searchterms_boxfolder = `<b>${boxterms.join(", ")}</b>`;
    }

    let searchdescription = ``;
    if (searchterms_textsearch && searchterms_boxfolder) {
        searchdescription = `Searching for ${searchterms_textsearch} in ${searchterms_boxfolder}`;
    }
    else if (searchterms_textsearch) {
        searchdescription = `Searching for ${searchterms_textsearch} in all boxes and folders`;
    }
    else if (searchterms_boxfolder) {
        searchdescription = `Showing all documents in ${searchterms_boxfolder}`;
    }

    $('#searchresults .searchterms').html(searchdescription);

    // fill in search results: tiles view and table view
    const $panel1 = $('#resultspanel-tiles').empty();  // tiles view
    const $panel2 = $('#resultspanel-table tbody').empty();  // table view

    SEARCHRESULTS.resultspage.forEach((document) => {
        const $box = $(`<a class="result container" href="${document.url}" target="_blank"></a>`).appendTo($panel1);

        let $image = $('<div class="missingimage"></div>');
        if (document.image) {
            $image = $(`<img src="${document.image}" />`);
        }
        $image.appendTo($box);

        const $foot = $('<div class="foot row"></div>').appendTo($box);
        const $footl = $('<div class="col left"></div>').appendTo($foot);
        const $footr = $('<div class="col right"></div>').appendTo($foot);
        if (document.numpages) {
            $(`<span class="numpages">${document.numpages} pages</span>`).appendTo($footl);
        }
        if (document.url) {
            $(`<span class="link">View</span>`).appendTo($footr);
        }
    });

    SEARCHRESULTS.resultspage.forEach((document) => {
        const $tr = $('<tr></tr>').appendTo($panel2);
        $('<td></td>').text(document.title).appendTo($tr);
        $('<td></td>').text(document.authors ? document.authors : 'Unknown').appendTo($tr);
        $('<td></td>').text(document.types ? document.types : 'Not Assigned').appendTo($tr);
        $('<td class="right"></td>').text(document.numpages ? document.numpages.toLocaleString() : '').appendTo($tr);
        $('<td></td>').html(document.url ? `<a href="${document.url}">View</a>` : '').appendTo($tr);
    });
}


function clearSearchResults () {
    SEARCHRESULTS = undefined;

    $('#resultspanel-tiles').empty();
    $('#resultspanel-table tbody').empty();
    $('#searchresults .searchterms').empty();
    $('#searchresults').hide();
    $('#noresults').hide();
    $('#searchform').show();
}


function selectResultsView (which) {
    const $panel1 = $('#resultspanel-tiles');  // tiles view
    const $panel2 = $('#resultspanel-table');  // table view

    const $buttons = $('#searchresults a[data-results-view]');
    const $thisone = $buttons.filter(`[data-results-view="${which}"]`);
    const $others = $buttons.not(`[data-results-view="${which}"]`);

    switch (which) {
        case 'tiles':
            $panel1.removeClass('d-none');
            $panel2.addClass('d-none');
            break;
        case 'table':
            $panel1.addClass('d-none');
            $panel2.removeClass('d-none');
            break;
        default:
            throw new Error(`selectResultsView() unknown selection ${which}`);
    }

    $thisone.removeClass('btn-link').addClass('btn-link-alt');
    $others.removeClass('btn-link-alt').addClass('btn-link');
}


function getCurrentPageNumber () {
    const $numbox = $('#searchform input[name="page"]');
    return parseInt( $numbox.val() );
}


function setCurrentPageNumber (p) {
    if (p < 1) p = 1;

    const $numbox = $('#searchform input[name="page"]');
    return $numbox.val(p);
}


function compileSearchParams (asstring=false) {
    const params = {
        boxfolder: $('#searchform select[name="boxfolder"]').val().join(','),
        textsearch: $('#searchform select[name="textsearch"]').val().join(','),
        doctypes: $('#searchform select[name="doctypes"]').val().join(','),
        keywords: $('#searchform select[name="keywords"]').val().join(','),
        authors: $('#searchform select[name="authors"]').val().join(','),
        docdate: $('#searchform select[name="docdatemin"]').val() + ',' + $('#searchform select[name="docdatemax"]').val(),
        page: getCurrentPageNumber(),
        sort: $('#searchresults .searchpagination select[name="sort_field"]').val() + ',' + $('#searchresults .searchpagination select[name="sort_ascdesc"]').val(),
        tileview: $('#searchresults a[data-results-view="tiles"]').hasClass('btn-link-alt') ? 'tiles' : '',
    };

    const paramstring = Object.entries(params).map(([ key, value ]) => { return key + '=' + encodeURIComponent(value); }).join('&');

    return asstring ? paramstring : params;
}


function updateUrlParams () {
    const paramstring = compileSearchParams(true);
    const base_url = document.location.href.indexOf('?') == -1 ? document.location.href : document.location.href.substr(0, document.location.href.indexOf('?'));
    const url = base_url + '?' + paramstring;
    window.history.replaceState({}, '', url);
}


function logSearchAnalytics () {
    const paramstring = compileSearchParams(true);
    logGoogleEvent('SearchPerformed', 'Search Page', paramstring );
}
